import type { ChatDocument } from '@/store/slices/chat/chat';
import type { Citation } from '@/types/chat';
import { getUniqueCitationDocumentIds } from './getUniqueCitationDocumentIds';

/**
 * The cited documents that aren't the chat's own files, for the chat documents dialog. The Sources
 * panel list also holds every upload, cited or not, so it can't be shown as is.
 */
export const getCitedCaseFiles = (
  sourcesPanelDocuments: ChatDocument[],
  citations: Pick<Citation, 'documentId'>[],
  chatFiles: ChatDocument[],
): ChatDocument[] => {
  const citedIds = new Set(getUniqueCitationDocumentIds(citations));
  const chatFileIds = new Set(chatFiles.map((file) => file.documentId));

  return sourcesPanelDocuments.filter(
    (document) => citedIds.has(document.documentId) && !chatFileIds.has(document.documentId),
  );
};
